// 仅针对 i9.taou.com 下的图片
export interface QINIULoaderParams {
  src: string;
  width: number;
  quality?: number;
}

export const QINIULoader = ({ src, width, quality }: QINIULoaderParams) =>
  `${src}?imageView2/2/w/${width}/q/${quality || 75}/format/webp`;

export default QINIULoader;
